import { useQuery } from "@tanstack/react-query";
import apiClient from "./apiClient";
import { config } from "../config";
import { useAppContext } from "../libs/appContextLib";

export const useFetchKnowledgebaseDb = () => {
    const { currUser } = useAppContext();

    return useQuery({
        queryKey: [`${currUser?.customerId}_knowledgebase-db`],
        queryFn: async () => {
            const response = await apiClient.get(
                `${config.REACT_APP_BACKEND_HOST}/knowledgebase-db`
            );
            return response.data;
        },
        staleTime: 5 * 60 * 1000,        // 5 minutes
        gcTime: 30 * 60 * 1000,          // 30 minutes
        refetchOnMount: false,           // Use cached data, don't refetch on mount
        refetchOnWindowFocus: false,     // Don't refetch on window focus
        enabled: !!currUser?.customerId
    });
};
